import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

/**
 * All backend logging should go through this class. Records errors happening in production.
 */
export class LogService {

  // https://github.com/loggly/loggly-jslogger
  // private loggly: any = new LogglyTracker();

  constructor() {

    /*
    this.loggly.push({
      sendConsoleErrors: false,
      tag: 'AngularJS-logs'
    });*/
  }

  logConsole(message: string, data?: any) {
    // console.log(message, data ? data: '');
  }

  logError(message: string) {
    console.log(message);

    /*
    // only send logs in prod
    if ( !isDevMode() && !this.utils.isStaging() ){
      this.loggly.push({ message: message });
    }*/
  }

}
